// import Swiper, { Keyboard, Navigation } from 'swiper'

let gallerySlider

// # main function
sliders()
function sliders() {
  addClassSwiper()

  if (document.querySelector('.slider-services')) {
    new Swiper(document.querySelector('.slider-services'), {
      direction: 'horizontal',
      effect: 'slide',
      loop: false,
      speed: 1000,
      spaceBetween: 24,
      slidesPerView: 1,
      watchOverflow: true,

      // modules: [Keyboard, Navigation],

      navigation: {
        nextEl: '.Services_services-second__rvahC .slick-next',
        prevEl: '.Services_services-second__rvahC .slick-prev',
      },

      keyboard: {
        enabled: true,
      },

      breakpoints: {
        490: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
      },
    })
  }

  if (document.querySelector('.slider-products')) {
    new Swiper(document.querySelector('.slider-products'), {
      direction: 'horizontal',
      effect: 'slide',
      loop: false,
      speed: 1000,
      spaceBetween: 24,
      slidesPerView: 1,
      watchOverflow: true,

      // modules: [Keyboard, Navigation],

      navigation: {
        nextEl: '.Products_services-second__wxI5r .slick-next',
        prevEl: '.Products_services-second__wxI5r .slick-prev',
      },

      keyboard: {
        enabled: true,
      },

      breakpoints: {
        490: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        992: {
          slidesPerView: 4,
        },
      },
    })
  }

  if (document.querySelector('.slider-reviews')) {
    new Swiper(document.querySelector('.slider-reviews'), {
      direction: 'horizontal',
      effect: 'slide',
      loop: true,
      speed: 1000,
      spaceBetween: 0,
      slidesPerView: 1,
      watchOverflow: true,
      initialSlide: 1,
      centeredSlides: true,

      // modules: [Keyboard, Navigation],

      navigation: {
        nextEl: '.Reviews_slick__mFk4E .slick-next',
        prevEl: '.Reviews_slick__mFk4E .slick-prev',
      },

      keyboard: {
        enabled: true,
      },

      breakpoints: {
        640: {
          slidesPerView: 2,
        },
      },
    })
  }

  if (document.querySelector('.slider-gallery')) {
    gallerySlider = new Swiper(document.querySelector('.slider-gallery'), {
      direction: 'horizontal',
      effect: 'slide',
      loop: false,
      speed: 1000,
      spaceBetween: 24,
      slidesPerView: 1,
      watchOverflow: true,

      // modules: [Keyboard, Navigation],

      navigation: {
        nextEl: '.gallery-btn-next',
        prevEl: '.gallery-btn-prev',
      },

      pagination: {
        el: '.slider-gallery__pagination',
        //# Рядок із типом розбивки на сторінки. Можуть бути 'bullets', 'fraction', 'progressbar' або 'custom'
        type: 'fraction',
        //# можна натиснути, коли <type>: 'bullets'
        // clickable: true,
        //# динамічні кулі, коли <type>: 'bullets'
        // dynamicBullets: true,
        //# Кількість основних маркерів, видимих, коли ввімкнено <dynamicBullets>.
        // dynamicMainBullets: 1,
      },

      keyboard: {
        enabled: true,
      },

      breakpoints: {
        640: {
          // slidesPerView: 2,
        },
      },
    })
  }

  if (document.querySelector('.form__slider')) {
    gallerySlider = new Swiper(document.querySelector('.form__slider'), {
      direction: 'horizontal',
      effect: 'slide',
      loop: false,
      speed: 1000,
      spaceBetween: 0,
      slidesPerView: 1,
      watchOverflow: true,

      // modules: [Keyboard, Navigation],

      navigation: {
        nextEl: '.Steps_button-div__bOCz0 .next',
        prevEl: '.Steps_button-div__bOCz0 .prev',
      },

      pagination: {
        el: '.progressbar-form',
        //# Рядок із типом розбивки на сторінки. Можуть бути 'bullets', 'fraction', 'progressbar' або 'custom'
        type: 'progressbar',
        //# можна натиснути, коли <type>: 'bullets'
        // clickable: true,
        //# динамічні кулі, коли <type>: 'bullets'
        // dynamicBullets: true,
        //# Кількість основних маркерів, видимих, коли ввімкнено <dynamicBullets>.
        // dynamicMainBullets: 1,
      },

      keyboard: {
        enabled: true,
      },
    })
  }
}

//# addClassSwiper
function addClassSwiper() {
  const $sliders = document.querySelectorAll('[class*="__swiper"]')

  $sliders.forEach(slider => {
    slider = slider.parentElement
    const wrapper = slider.children[0]
    const slides = Array.from(wrapper.children)

    slider.classList.add('swiper')
    wrapper.classList.add('swiper-wrapper')
    slides.forEach(addClassSlide)
  })
}

//# addClassSlide
function addClassSlide(slide) {
  slide.classList.add('swiper-slide')
}

export const getGallerySlider = () => gallerySlider
